var createJournalController = require("../../util/journalControllerFactory") ;

module.exports = createJournalController({
    gridRoute: "account-journals",
    formRoute: "account-journal-form",
    importerRoute: "account-journal-importer",
}) ;
